import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Review12Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Review12IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6299 12C21.6299 16.9706 17.6004 21 12.6299 21V12V3C17.6004 3 21.6299 7.02944 21.6299 12ZM12.6299 2C18.1527 2 22.6299 6.47715 22.6299 12C22.6299 17.5228 18.1527 22 12.6299 22C9.87665 22 7.38329 20.8873 5.57493 19.0871C5.56955 19.0818 5.56418 19.0764 5.55881 19.0711C5.55345 19.0657 5.54809 19.0603 5.54274 19.055C3.74254 17.2466 2.62988 14.7532 2.62988 12C2.62988 6.47715 7.10704 2 12.6299 2Z"
        fill="url(#paint0_linear_7623_93)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7623_93"
          x1="2.62988"
          y1="13.8478"
          x2="22.6299"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Review12Icon;
